import { Stack, Box, Heading, Text, Tiles, Link } from 'braid-design-system';

import { createDotNetLinkUrl } from 'src/utils';

import * as styles from './FindAFranchiseOpp.css';

interface ItemProps {
  text: string;
  link: string;
}

const Item = (props: ItemProps) => (
  <Link
    href={createDotNetLinkUrl(
      `/businesses-for-sale/only-franchises/${props.link}`,
    )}
  >
    <Box
      borderRadius="full"
      paddingY="small"
      paddingX="medium"
      height="full"
      width="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxShadow="borderNeutralLight"
      style={{ minHeight: 70 }}
      className={styles.pill}
    >
      <Text size="small" weight="strong" align="center">
        {props.text}
      </Text>
    </Box>
  </Link>
);

const ByIndustry = () => (
  <Stack space="medium">
    <Text>Explore franchise opportunities by industry.</Text>

    <Tiles columns={{ mobile: 2, tablet: 4 }} space="small">
      <Item text="Food &amp; Drink" link="within-food-and-drink" />
      <Item
        text="Health, Beauty &amp; Fitness"
        link="within-health-beauty-fitness"
      />
      <Item text="Retail" link="within-retail" />
      <Item text="Commercial Services" link="within-commercial-services" />
      <Item text="Personal Services" link="within-personal-services" />
      <Item
        text="Cleaning &amp; Maintenance"
        link="within-cleaning-and-maintenance"
      />
    </Tiles>
  </Stack>
);

const ByLocation = () => (
  <Stack space="medium">
    <Text>Explore franchise opportunities by locations.</Text>

    <Tiles columns={{ mobile: 2, tablet: 4 }} space="small">
      <Item text="Melbourne" link="in-melbourne-vic" />
      <Item text="Sydney" link="in-sydney-nsw" />
      <Item text="Brisbane" link="in-brisbane-qld" />
      <Item text="Perth" link="in-perth-wa" />
      <Item text="Adelaide" link="in-adelaide-sa" />
      <Item text="Hobart" link="in-hobart-tas" />
      <Item text="Darwin" link="in-darwin-nt" />
      <Item text="Canberra" link="in-act-act" />
    </Tiles>
  </Stack>
);

const FindAFranchiseOpp = () => (
  <Stack space="large">
    <Heading level="3" component="h2">
      Find a franchise opportunity
    </Heading>

    <ByIndustry />
    <ByLocation />
  </Stack>
);

export default FindAFranchiseOpp;
